var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWelcome(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 158.553,
    height: 223.777,
    viewBox: "0 0 158.553 223.777",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2012",
    "data-name": "Rectangle 2012",
    width: 87.137,
    height: 215.726,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_22182",
    "data-name": "Group 22182",
    transform: "translate(-878.965 -256.199)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11341",
    "data-name": "Path 11341",
    d: "M158.553,352.668c0,4.448-35.493,8.052-79.276,8.052S0,357.116,0,352.668s35.493-8.052,79.276-8.052,79.276,3.606,79.276,8.052",
    transform: "translate(878.965 119.256)",
    fill: "#7586ec",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_22181",
    "data-name": "Group 22181",
    transform: "translate(914.672 256.196)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_22180",
    "data-name": "Group 22180",
    transform: "translate(0 0.003)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11323",
    "data-name": "Path 11323",
    d: "M135.585,1149c.24-1.721-.3-4.683-1.647-9.314,2.669.006,4.913-1.175,7.64-1.134.745,4.356,1.9,11.509,1.9,11.509l.123,5.655-18.991.143s.158.081,5.757-3.456c.414-.262,4.987-1.739,5.219-3.4",
    transform: "translate(-103.037 -941.447)",
    fill: "#ffb27d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11324",
    "data-name": "Path 11324",
    d: "M137.575,1211.726h-19.6c-.725-.065-.9-.657-.65-1.021.517-.751,4.341-2.553,6.912-3.749,4.509.475,12.434-1.381,13.146-2.426,1.236,3.459.6,7.108.2,7.2",
    transform: "translate(-96.92 -996)",
    fill: "#040227"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11325",
    "data-name": "Path 11325",
    d: "M272.242,1150.806a32.556,32.556,0,0,0,.05-9.617c2.669.006,5.208-.494,7.936-.453,0,4.482-.094,11.131-.094,11.131l.124,5.655-18.991.143s.158.081,5.757-3.456c.414-.261,4.987-1.739,5.219-3.4",
    transform: "translate(-216.035 -943.249)",
    fill: "#ffb27d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11326",
    "data-name": "Path 11326",
    d: "M274.229,1211.726h-19.6c-.725-.065-.9-.657-.651-1.021.518-.751,4.342-2.553,6.912-3.749,4.509.475,12.434-1.381,13.146-2.426,1.237,3.459.6,7.108.2,7.2",
    transform: "translate(-209.916 -996)",
    fill: "#040227"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11327",
    "data-name": "Path 11327",
    d: "M138.464,486.432l5.793,3.231,11.775,18-21.059,49.566s2.371,7.454,3.144,11.178c.808,3.9,2.791,37.339,2.791,37.339l-8.984.151s-8.533-35.6-9.978-47.157c-1.755-14.032,8.93-47.451,8.93-47.451,1.992-6.819,6.289-20.845,6.289-20.845s1.051-3.418,1.3-4.016",
    transform: "translate(-100.674 -402.221)",
    fill: "#6392dc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11328",
    "data-name": "Path 11328",
    d: "M238.451,447.37a16.96,16.96,0,0,0,1.8,9.067c1.46,2.945,3.983,5.254,5.789,8.862,3.419,6.827,5.275,16.525,3.993,22.758,0,0-7.068,26.992-6.788,36.856.1,3.638,1.352,10.192,2.15,14.623.706,3.917.458,32.975.458,32.975l-9.546.185-7.683-47.661-3.248-42.365-7.086-28.535Z",
    transform: "translate(-180.498 -369.921)",
    fill: "#699dee"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11329",
    "data-name": "Path 11329",
    d: "M197.492,14.486c.926-4.375,1.882-8.766,6.23-11.918A11.6,11.6,0,0,1,215.028.743c11.356,4.119,5.248,13.131,19.34,22.736,4.379,2.985,6.041,4.025,9.184,8,4.4,5.567,6.8,13.037,4.592,19.187-4.573,12.717-18.741,16.392-26.153,13.7-13.8-5.019-25.29-22.515-26.054-27.29-.817-5.11.958-19.771,1.554-22.588",
    transform: "translate(-161.842 -0.003)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11330",
    "data-name": "Path 11330",
    d: "M42.156,104.124l-6.82-7.831s-7.816,3.879-16.892,7.518c-2.268-4.364-5.673-18.55-5.86-19.228s5.064-8.893,3.977-9.151-2.706,4.391-3.844,3.865S9.065,67.725,8.343,68.291c-1.351,1.06,1.279,6.859.574,7.244s-2.165-6.4-3.5-6.166,1.983,6.2,1.568,6.744-3.914-5.075-4.737-3.842c-.447.669,3.239,4.9,2.426,5.321S.489,75.3.039,76.117s3.173,1.831,4.1,3.975,2.74,3.039,3.185,7.036,1.226,25.292,5.482,27.178c3.716,1.648,29.349-10.182,29.349-10.182",
    transform: "translate(0 -56.452)",
    fill: "#ffb27d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11331",
    "data-name": "Path 11331",
    d: "M176.595,198.636a7.7,7.7,0,0,0,.374-6.235c-5.2,3.165-13.06,8.556-13.06,8.556a72.51,72.51,0,0,0,4.186,11.988c4.821-2.854,5.328-2.954,5.328-2.954,2.157-10.3,3.172-11.356,3.172-11.356",
    transform: "translate(-135.533 -159.093)",
    fill: "#262d4e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11332",
    "data-name": "Path 11332",
    d: "M204.908,189.38c3.929-1.032,4.724-.516,12.011-.408,11.163.159,16.8-2.413,23.236,26.2a26.961,26.961,0,0,1-10.259,1.68c-.664-3.3-.623-9.162-1.811-5.514a106.074,106.074,0,0,0-3.989,16.8c-.56,3.4-1.778,7.741-1.137,11.2a103.779,103.779,0,0,1-13.41,1.82.224.224,0,0,1-.049,0,45.539,45.539,0,0,1-8.239-.87s-1.15-24.066-1.747-25.078c-6.181-10.474,5.394-25.825,5.394-25.825",
    transform: "translate(-163.472 -156.071)",
    fill: "#040227"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11333",
    "data-name": "Path 11333",
    d: "M260.084,120.218s.889,7.179,1.413,9.672c.549,2.608,1.374,10.821-4.035,12.155s-3.736-8.937-3.826-11.588-1.621-11.9-1.621-11.9Z",
    transform: "translate(-208.385 -98.034)",
    fill: "#ffb27d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11334",
    "data-name": "Path 11334",
    d: "M260.378,122.509c-.055.033-.106.069-.163.1-2.989,1.714-5.591,1.443-7.543.11-.349-2.3-.658-4.162-.658-4.162l8.07,1.66s.119.957.294,2.291",
    transform: "translate(-208.385 -98.034)",
    fill: "#ed975d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11335",
    "data-name": "Path 11335",
    d: "M240.06,19.3a9.253,9.253,0,0,1,5,4.038c1.827,3.147,2.739,12.186-3.988,16.042s-11.5-2.323-11.3-8.1S231.585,17.849,240.06,19.3",
    transform: "translate(-189.988 -15.811)",
    fill: "#ffb27d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11336",
    "data-name": "Path 11336",
    d: "M221.187,62.39c-.075,1.5.568,2.756,1.436,2.8s1.632-1.138,1.706-2.641-.568-2.756-1.436-2.8-1.631,1.139-1.706,2.641",
    transform: "translate(-182.89 -49.404)",
    fill: "#ffb27d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11337",
    "data-name": "Path 11337",
    d: "M283.732,18.783s3.627,9.453,7.175,10.461,3.266,5.658,3.266,5.658.454-10.748-2.788-13.383a14.086,14.086,0,0,0-7.653-2.735",
    transform: "translate(-234.612 -15.532)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11338",
    "data-name": "Path 11338",
    d: "M315.164,79.935c-.547,1.478-.189,2.978.8,3.351s2.236-.522,2.784-2,.188-2.978-.8-3.351-2.236.522-2.784,2",
    transform: "translate(-260.391 -64.373)",
    fill: "#ffb27d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11339",
    "data-name": "Path 11339",
    d: "M187.322,352.818c-.131-.024-.672-.279-1.137-.416a9.221,9.221,0,0,0-1.233-.276,3.539,3.539,0,0,0-.588-.673c-.17-.156-.484-.294-.674-.468s-.325-.437-.51-.6c-.486-.427-.986-.65-1.253-.409-.221.2,2.3,3.131,2.3,3.131,2.9.952,5.471,3.412,13.623,1.181,4.389-.445,26.048-3.672,27.07-5.564.574-1.061.514-10.724.3-18.114-2.068.228-6.461.7-8.9.915.63,4.813,1.176,11.1.713,11.7-.119.157-.456.4-15.75,4.615-.385.1-.78.215-1.18.325-1.076.3-2.228.612-3.448.943l-3.483-1.534s-5.834-1.44-6.214-.845c-.169.273.256.573.81.845l.017.006.246.117.011,0c.6.276,1.262.5,1.4.608a3.926,3.926,0,0,1,.725.7c-4.025.311-3.585-.12-4.741-.573-.289-.118-.63-.134-.9-.246-.466-.194-.756-.6-1.12-.743a1.686,1.686,0,0,0-1.182-.022c-.166.086.009.343.4.7,2.366,2.075,4.788,2.349,5.461,2.76.452.277-.5.172-1.852-.425a7.76,7.76,0,0,1-1.261-.424c-.286-.167-.5-.457-.78-.628-.257-.158-.544-.244-.763-.365-.29-.156-.642-.527-.879-.634a2.442,2.442,0,0,0-1.505-.327c-.271.12,3.363,3.043,3.363,3.043s2.725,1.329,3.364,1.533c0,0,.327.294-.456.168",
    transform: "translate(-149.696 -273.371)",
    fill: "#ffb27d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11340",
    "data-name": "Path 11340",
    d: "M393.839,332.849a26.606,26.606,0,0,1-8.636,1.327c-.1-.905-.21-1.8-.322-2.657,2.439-.21,6.832-.686,8.9-.915.021.729.04,1.481.058,2.244",
    transform: "translate(-318.25 -273.371)",
    fill: "#262d4e",
    stroke: "#262d4e",
    strokeWidth: 1
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWelcome);
export default __webpack_public_path__ + "static/media/welcome.9e13d9f2f1754e6529d6f40b29b8eac9.svg";
export { ForwardRef as ReactComponent };